/**
 * Email obfuscation helpers.
 *
 * The public address is never stored as a complete literal string in the
 * source or in the compiled bundle. It is kept as separate base64-encoded
 * fragments and only reassembled at runtime, after an explicit user action.
 *
 * This only discourages trivial scrapers — it is not bot-proof.
 */

/** base64 fragments: local part, domain label, top-level domain */
const PARTS = ["Y29udGFjdA==", "b2NlYW5ub3Zh", "cGw="];

const decode = (value: string): string => atob(value);


/**
 * Reassembles the public address. Call only in response to an explicit
 * user action (e.g. clicking the "show email address" button).
 */
export const revealEmail = (): string => {
  const [user, domain, tld] = PARTS.map(decode);
  return `${user}${String.fromCharCode(64)}${domain}.${tld}`;
};
